// extracted by mini-css-extract-plugin
export var downArrow = "_il-0";
export var infoTooltipIcon = "_il-3";
export var label = "_il-1";
export var optionCard = "_il-4";
export var upArrow = "_il-2";